<t<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 style="margin-bottom: 0px;">REPORTES</h5>
            <h6 style="margin-top: 0px;">Reporte de documentos de ingreso y reingreso por Área y año</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area" style="margin-top: 0px">
                    <div>
                        <h6 style="margin-top: 0px;">Parametros</h6>
                    </div>
                    <div class="row">
                            <div class="form-group col-4" id="Busqueda_div">
                                <label>Área:</label>
                                <CAreas
                                v-on:valorParaElPadre="cambioDeArea" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'filtroDeBusqueda_Area'" 
                                :parametros="parametros_Area" 
                                :valorDefinido="parametros_Area.areaId" 
                                :key="parametros_Area.areaId"
                                >
                                </CAreas>
                            </div>
                            <div class="form-group col-2">
                                <label>Año:</label>
                                <input class="form-control" type="Number" v-model="Busqueda.Anio">
                            </div>
                            <div class="form-group col-1" style="margin-top: 26px;">
                                <button class="btn btn-sm btn-primary" @click='ObtenerReporte()'>Generar Reporte</button>
                            </div>
                    </div>
                    
                </div>
                <div class="area" Id="resultado_div">
                    <div v-if="this.Ingreso.length>0">
                        <TIngreso 
                        :Datos= this.Ingreso 
                        :EtiquetaArea= this.Etiqueta.AreaReporte 
                        :EtiquetaAnio= this.Etiqueta.AnioReporte
                        :Ingreso = true
                        :Solicitud = false
                        :HNombre= this.headName></TIngreso>
                    </div>
                    <div v-if="this.Regreso.length>0">
                        <TRegreso
                        :Datos= this.Regreso 
                        :EtiquetaArea= this.Etiqueta.AreaReporte 
                        :EtiquetaAnio= this.Etiqueta.AnioReporte
                        :Ingreso = false
                        :Solicitud = false
                        :HNombre= this.headName></TRegreso>
                    </div>
                    
                </div>
                <div class="area" v-if="Ingreso.length>0">
                    <div class="text-right">
                        <button class="btn btn-sm btn-dark" @click='ImprimirReporte()' >Imprimir Reporte</button>      
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    
    
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import Tablas from '@/components/ArchivoJudicial/Comun/TablasIngreso.vue'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'


export default {
    components:{
        CAreas: catalogos.ArchivoJudicial.C001Areas,
        TIngreso: Tablas,
        TRegreso: Tablas
    },
     data(){
        return{
            enumeraciones,
            parametros_Area: {
              areaId: -1,
              Nombre: "",
              conMaterias: true
            },
            Busqueda: {
                Anio: parseInt(moment().format('YYYY'))
            },
            Ingreso: [],
            Regreso: [],
            Etiqueta:{
                AreaReporte: "",
                AnioReporte: 0
            },
            headName: ""
        }
    },
     methods :{
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.parametros_Area.Nombre = datos[0].target.selectedOptions[0].text;
        },
        ObtenerReporte(){
            if(this.ValidarDatos())
            {
                var peticion = {
                    "AreaId" : this.parametros_Area.areaId,
                    "Año": this.Busqueda.Anio
                }
                this.Regreso = [];
                this.Ingreso = [];
                this.Etiqueta.AreaReporte = this.parametros_Area.Nombre;
                this.Etiqueta.AnioReporte = this.Busqueda.Anio;
                this.headName = "Año";
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.ReporteNuevoIngreso, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {   
                            this.Ingreso = respuesta.data.Resultado;
                            this.Regreso = respuesta.data.ReIngresos;
                            
                            comun.SeEstaCargandoInformacion(false);

                            if (this.Ingreso.length == 0 && this.Regreso.length== 0)
                            {
                                comun.mensajeDeAlerta("No hay Resultados para esta Área y Año seleccionado", null, null);
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }); 
            }
        },
        ValidarDatos(){
            if(this.parametros_Area.areaId == -1)
            {
              comun.mensajeDeAlerta("Seleccione una Área para obtener Reporte.", null, null);
              return false;
            }
            if(this.Busqueda.Anio == 0 || this.Busqueda.Anio == null)
            { comun.mensajeDeAlerta("Indicar año de ingreso correcto.", null, null);
                    return false;
            };
            
            if(this.Busqueda.Anio >parseInt(moment().format('YYYY')))
            { comun.mensajeDeAlerta("El año de ingreso no puede ser mayor al año corriente", null, null);
                    return false;
            };
            
            return true; 
        },
        ImprimirReporte(){
          var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">INGRESOS / REINGRESOS POR AREA</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="area">');
            
            var areaImpresion = document.getElementById('resultado_div').innerHTML;
            printWin.document.write(areaImpresion);
            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
        
    }

}
</script>




// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Reportes/IngresoReingresoArea.vue